const gaugeTableColumnCount = (table) => {
  if (table.children.length === 0) {
    return 0;
  }
  const rowSampleStart = table.children[0];
  const rowSampleMiddle = table.children[Math.floor(table.children.length / 2)];
  const rowSampleEnd = table.children[table.children.length - 1];
  const columnSampleStart = rowSampleStart.children.length;
  const columnSampleMiddle = rowSampleMiddle.children.length;
  const columnSampleEnd = rowSampleEnd.children.length;
  if (columnSampleStart === columnSampleEnd) {
    return columnSampleStart;
  }
  if (columnSampleStart === columnSampleMiddle) {
    return columnSampleStart;
  }
  if (columnSampleMiddle === columnSampleEnd) {
    return columnSampleMiddle;
  }
  return columnSampleStart;
};
export {
  gaugeTableColumnCount
};
//# sourceMappingURL=gaugeTableColumnCount.js.map
